import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Config from '../../../utils/config.service';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import AppLanguageService from '../../../services/app-language.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'sk-auth',
	templateUrl: './pre-visit-sso.component.html',
	imports: [
		CommonModule, TranslateUnauthenticatedPipe, ItemErrorComponent, RouterLink,
		ItemFormErrorWithTranslatorComponent, FormsModule
	]
})
export default class PreVisitSsoComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	vm: any = undefined;
	private titleSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var currentSession = this.session.getSession();
		var origin: any = (currentSession && currentSession.user && currentSession.user.origin)
			? currentSession.user.origin
			: 'minudoc.ee';
		this.vm.origin = origin;

		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.isPrevisit = true;
		}
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = queryParams['locale'] || 'en_GB';
		this.vm.localeParams = this.vm.locale ? { locale: this.vm.locale } : undefined;
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(origin);
		var currentSession = this.session.getSession();
		
		var params: any = {};
		params.ticketId = queryParams['ticketId'];
		params.source = queryParams['source'];
		params.idCode = queryParams['idCode'];
		var signatureParam = queryParams['signature'];
		if (signatureParam) {
			params.signature = signatureParam;
		}
		params.timestamp = queryParams['timestamp'];
		this.restService.getSsoAuthResult(params)
			.then((response) => {
				setTimeout(() => {
					if (response.authRequired) {
						this.angularRoutingHelperService.setPath('sk-auth', false, false, { targetUrl: 'pre-visit-chat/' + response.id });
					} else {
						window.location.replace(window.location.origin + "/app/#/pre-visit-chat/" + response.id);
					}
				}, 200);
			})
			.catch((error) => {
				this.vm.initialized = true;
				this.vm.errorMessage = error.error;
				console.log(error);
			});
		
		this.vm.language = window.navigator.language;
		this.vm.lang = window.sessionStorage.getItem("locale") || 'et_EE' ;
		
		this.vm.setLocale = this.setLocale;
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.getLocaleOption = this.getLocaleOption;
		
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Login.Login_Title');
	}

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getBaseUrl();
	}
	
	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
}
